import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Wrong",
  "use": "icon-Wrong-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-Wrong\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 14.667A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334Zm2.471-9.138c.26.26.26.682 0 .942L8.943 8l1.528 1.529a.667.667 0 0 1-.942.942L8 8.943 6.471 10.47a.667.667 0 1 1-.942-.942L7.057 8 5.53 6.471a.667.667 0 1 1 .942-.942L8 7.057 9.529 5.53c.26-.26.682-.26.942 0Z\" fill=\"#395BBE\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol